import { Component, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'app-carousel-el-departments',
  templateUrl: './carousel-el-departments.component.html',
  styleUrl: './carousel-el-departments.component.scss',
})
export class CarouselElDepartmentsComponent {
  departments = [
    {
      title: 'قطاع الصناعات الغذائية',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع الاتصالات وتكنولوجيا المعلومات',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع العقارات',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع صناعة السيارات',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع تجارة التجزئة',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع صناعة السيارات',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع تجارة التجزئة',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع صناعة السيارات',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
    {
      title: 'قطاع تجارة التجزئة',
      description:
        'المحاصيل الزراعية هي المدخلات الأساسية لتصنيع الصناعات الغذائية',
      image: '../../../assets/department.png',
      link: '#',
    },
  ];

  @Input() TeamTitle!: string;
  @ViewChild('slickModal', { static: false })
  slickModal?: SlickCarouselComponent;

  isFullScreen: boolean = false;
  sliderConfig: any = {};

  constructor() {
    this.sliderConfig = {
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: false, 
      rtl: true, 
      speed: 300,
      pauseOnHover: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 3, slidesToScroll: 1 },
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    };
  }

  changeEvent(event: any) {
    const currentSlickElements = Array.from(
      document.getElementsByClassName('slick-active')
    ) as HTMLElement[];

    if (window.innerWidth > 768) {
      currentSlickElements.forEach((element: HTMLElement) => {
        element.style.transform = 'scale(0.9)';
      });
      (
        currentSlickElements[0]?.nextElementSibling as HTMLElement
      ).style.transform = 'scale(1.2)';
    }
  }

  moveSlider(dir: boolean) {
    console.log('askasklas');
    dir ? this.slickModal?.slickNext() : this.slickModal?.slickPrev();
  }
}
